import { Link } from "react-router-dom";
import { LogOut, LogIn, UserPlus, User2, Key } from "lucide-react";
import { getMemberAppreciation } from "../utils/member-appreciation";

export const UserSection = ({ user, onSignOut, collapsed, mobileOpen }) => {
  const appreciation = user?.metadata?.creationTime
    ? getMemberAppreciation(user.metadata.creationTime)
    : { accent: "border-gray-200" };

  return (
    <div className="w-full space-y-2">
      <div
        className={`flex items-center min-h-12 px-3 py-2 rounded-lg bg-gray-50 text-gray-700 border-l-4 ${appreciation.accent} ${
          collapsed && !mobileOpen ? "justify-center" : ""
        }`}
      >
        <User2 className="w-4 h-4" strokeWidth={1.5} />
        {(!collapsed || mobileOpen) && (
          <div className="ml-2 overflow-hidden flex-1">
            <div className="text-sm font-medium truncate">{user?.email || "Anonymous"}</div>
            {appreciation.memberSince && (
              <div className="text-xs text-gray-500">
                Member since {appreciation.memberSince}
              </div>
            )}
          </div>
        )}
      </div>

      <Link
        to="/api-keys"
        className={`w-full flex items-center h-10 px-3 text-gray-600 hover:bg-gray-100 hover:text-gray-800 rounded-lg transition-all duration-200 ${
          collapsed && !mobileOpen ? "justify-center" : ""
        }`}
      >
        <Key className="w-4 h-4" strokeWidth={1.5} />
        {(!collapsed || mobileOpen) && (
          <span className="ml-2 text-sm font-medium">API Keys</span>
        )}
      </Link>

      <button
        onClick={onSignOut}
        className={`w-full flex items-center h-10 px-3 text-red-600 hover:bg-red-50 hover:text-red-700 rounded-lg transition-all duration-200 ${
          collapsed && !mobileOpen ? "justify-center" : ""
        }`}
      >
        <LogOut className="w-4 h-4" strokeWidth={1.5} />
        {(!collapsed || mobileOpen) && (
          <span className="ml-2 text-sm font-medium">Sign Out</span>
        )}
      </button>
    </div>
  );
};

export const AuthButtons = ({ collapsed, mobileOpen }) => (
  <div className="space-y-2">
    <Link
      to="/signin"
      className={`w-full flex items-center h-10 px-3 text-blue-600 hover:bg-blue-50 hover:text-blue-700 rounded-lg transition-all duration-200 ${
        collapsed && !mobileOpen ? "justify-center" : ""
      }`}
    >
      <LogIn className="w-4 h-4" strokeWidth={1.5} />
      {(!collapsed || mobileOpen) && (
        <span className="ml-2 text-sm font-medium">Sign In</span>
      )}
    </Link>
    <Link
      to="/signin?signup=true"
      className={`w-full flex items-center h-10 px-3 text-green-600 hover:bg-green-50 hover:text-green-700 rounded-lg transition-all duration-200 ${
        collapsed && !mobileOpen ? "justify-center" : ""
      }`}
    >
      <UserPlus className="w-4 h-4" strokeWidth={1.5} />
      {(!collapsed || mobileOpen) && (
        <span className="ml-2 text-sm font-medium">Create Account</span>
      )}
    </Link>
  </div>
);
